<template>
  <div>
    <v-breadcrumbs class="pa-4" :items="breadcrumb" large></v-breadcrumbs>

    <v-container class="fill-height pa-0" fluid>
      <v-row>
        <v-col cols="12" sm="8" md="8">
          <v-card>
            <v-card-text>
              <v-form enctype="multipart/form-data" ref="form" v-model="valid">
                <v-row no-gutters class="mb-8 pt-4">
                  <v-col cols="3" align-self="center">
                    <label class="image-input">
                      <img v-if="!image" class="my-avatar" :src="image_url" alt="Imagem de perfil">
                      <v-img v-else class="my-avatar" :src="url"></v-img>
                      <v-file-input name="avatar" hide-input accept="image/png, image/jpeg, image/bmp" prepend-icon=""
                        outlined dense ref="file" v-model="image" @change="previewImage"></v-file-input>
                    </label>
                  </v-col>
                </v-row>

                <v-text-field dense outlined v-model="name" :rules="nameRules" label="Nome" autocomplete="on" required
                  v-on:keypress="keyPress"></v-text-field>

                <v-text-field disabled dense outlined v-model="email" :rules="emailRules" label="E-mail" autocomplete="on"
                  required v-on:keypress="keyPress"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <reset-password-modal text small title="Alterar senha"
                description="Informe o email cadastrado que enviaremos um email para a alteração da senha."
                action-text="Alterar senha" :onSuccess="onResetPasswordSuccess" class="mr-2" />
              <v-btn small color="primary" @click="redirect" class="px-5 mr-2"
                v-if="!facebook_access_token && hasFacebookPermission">
                Vincular com Facebook
              </v-btn>
              <v-btn :loading="facebookLoading" color="error" @click="unlink" class="px-5"
                v-if="facebook_access_token && hasFacebookPermission">
                Desvincular Facebook
              </v-btn>
              <v-btn small :disabled="!valid" :loading="loading" color="primary" @click="submit" class="px-5 ml-2">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import ResetPasswordModal from '@/components/ResetPasswordModal'
import imageDefault from '@/assets/no-avatar.png'
import { handleResponseError } from '@/api/handleError'
import { mapState } from 'vuex'
// import axios from 'axios';

export default {
  name: 'Profile',
  components: {
    ResetPasswordModal
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  created() {
    this.email = this.user.email
    this.name = this.user.name
    this.image_url = this.user.image_path || imageDefault
    this.facebook_access_token = this.user.facebook_access_token

    const permissions = this.user.permissions
    permissions.forEach(item => {
      if (item.name === 'Gerenciar locais do Facebook') {
        this.hasFacebookPermission = true
      }
    })

    if (this.$route.query.facebook === 'success') {
      this.showNotification('Conta do Facebook vinculada com sucesso!', 'green')
      this.$router.replace({ query: { ...this.$route.query, facebook: undefined } })
    }
  },
  data: () => ({
    breadcrumb: [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/dashboard',
      },
      {
        text: 'Perfil',
        disabled: true,
        href: '',
      }
    ],
    valid: false,
    url: '',
    image_url: '',
    image: null,
    imageUpload: null,
    snackbar: {
      text: '',
      show: false,
      color: '',
    },
    loading: false,
    facebookLoading: false,
    email: '',
    emailRules: [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'E-mail inválido',
    ],
    name: '',
    nameRules: [
      v => !!v || 'Nome é obrigatório'
    ],
    fileRules: [
      value => !value || value.size < 2000000 || 'O tamanho da imagem deve ser menor que 2 MB!',
    ],
    hasFacebookPermission: false,
    facebook_access_token: ''
  }),
  methods: {
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    keyPress: function (e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.submit()
      }
    },
    submit: async function () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      try {
        let formData = new FormData()
        if (this.image) formData.append('photo', this.image)
        formData.append('name', this.name)
        formData.append('email', this.email)
        formData.append('_method', 'put')

        await this.$store.dispatch('auth/updateProfile', formData)
          .then(() => {
            this.loading = false
            this.showNotification('Perfil atualizado!', 'green')
          })
          .catch(e => {
            this.loading = false
            const message = handleResponseError(e)
            this.showNotification(message, 'red darken-2')
          })
      } catch (e) {
        const message = handleResponseError(e)
        this.showNotification(message, 'red darken-2')
      }
    },
    onResetPasswordSuccess: function () {
      this.showNotification('Email enviado! Caso não encontre verifique a caixa de spam', 'green')
    },
    previewImage(file) {
      if (file.size > 2000000) {
        this.showNotification('O tamanho da imagem deve ser menor que 2 MB!', 'red darken-2')
      } else {
        this.url = URL.createObjectURL(this.image)
      }
    },
    redirect: async function () {
      const route =`${process.env.VUE_APP_URL}/facebook/redirect?email=`+`${this.email}`;
      window.open(route, '_self');
    },
    unlink: async function () {
      this.facebookLoading = true
      try {
        let formData = new FormData()
        formData.append('facebook_access_token', 'unlink')
        formData.append('_method', 'put')

        await this.$store.dispatch('auth/updateProfile', formData)
          .then(() => {
            this.facebookLoading = false
            this.facebook_access_token = null
            this.showNotification('Facebook desvinculado!', 'green')
          })
          .catch(e => {
            this.facebookLoading = false
            const message = handleResponseError(e)
            this.showNotification(message, 'red darken-2')
          })
      } catch (e) {
        const message = handleResponseError(e)
        this.showNotification(message, 'red darken-2')
      }
    }
  },
  watch: {
    user: function (user) {
      this.email = user.email
      this.name = user.name
      this.image_url = user.image_path || imageDefault
      this.facebook_access_token = user.facebook_access_token

      const permissions = user.permissions
      permissions.forEach(item => {
        if (item.name === 'Gerenciar locais do Facebook') {
          this.hasFacebookPermission = true
        }
      })
    }
  }
}
</script>

<style scoped>
.my-avatar {
  object-fit: cover;
  height: 80px;
  width: 80px;
  border-radius: 50%;
}

.image-input {
  cursor: pointer;
}
</style>